import { EYE_ITEM_DEF_ID, useUnlockAchievement } from '@shared'
import { AchievementSlug, useInventory, useInventoryActions } from '@store'

import { ModalContent } from '../modalContent/ModalContent'

export const NewCardModal = () => {
  const newCards = useInventory.store.newCards()
  const { clearNewCard } = useInventoryActions()
  const { unlockAchievement } = useUnlockAchievement()

  const currentCard = newCards?.length !== 0 ? newCards[0] : null

  const handleClose = () => {
    if (currentCard && currentCard.defId === EYE_ITEM_DEF_ID) {
      unlockAchievement(AchievementSlug.FIRST_GLANCE)
    }

    clearNewCard()
  }

  if (!currentCard) {
    return null
  }

  return (
    <ModalContent card={currentCard} onClose={handleClose} state="preview" />
  )
}
